import axios from "./axios";

const Events = {
  /**
   * Fetches all Events's
   *
   * @return {array} Array of Events's
   */
  async get(perPage, currentPage, pagesToLoad = 1) {
    try {
      const res = await axios.get("/events", {
        params: { perPage, currentPage, pagesToLoad },
      });
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: [],
      };
    }
  },

  async getCustomEvents(perPage, currentPage, pagesToLoad = 1) {
    try {
      const res = await axios.get("/events/custom_events", {
        params: { perPage, currentPage, pagesToLoad },
      });
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: [],
      };
    }
  },

  async getEventTickets(eventId, perPage, currentPage, pagesToLoad = 1) {
    try {
      const res = await axios.get(`/events/event_tickets/${eventId}`, {
        params: { perPage, currentPage, pagesToLoad },
      });

      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: [],
      };
    }
  },

  /**
   * Fetches one Events by it's ID
   *
   * @param {string} id ID of the Events
   * @return {object} Events with the corresponding ID
   */
  async getById(eventsId) {
    try {
      const res = await axios.get("/events/" + eventsId);
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Fetches one public  Event by it's ID
   *
   * @param {string} id ID of the Events
   * @return {object} Events with the corresponding ID
   */
  async publicGetById(eventsId) {
    try {
      const res = await axios.get("/events/public/" + eventsId);
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Creates one Events
   *
   * @param {object} events Object with the creation data
   * @return {object} Newly created Events
   */
  async create(events) {
    let reqBody = { ...events };
    try {
      const res = await axios.post("/events", reqBody);
      return {
        ok: true,
        data: res.data,
      };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Creates one transaction per event
   *
   * @param {object} events Object with the creation data
   *
   */
  async purchaseTicket(data) {
    let reqBody = { ...data };
    try {
      const res = await axios.post(
        `/events/purchase_tickets?eventId=${reqBody.eventId}&quantity=${reqBody.quantity}&value=${reqBody.value}&fullName=${reqBody.fullName}&email=${reqBody.email}&phone=${reqBody.phone}&company=${reqBody.company}`
      );
      return {
        ok: true,
        data: res.data,
      };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Fetch all the purchases
   *
  
   */
  async getAllPurchases(perPage, currentPage, pagesToLoad = 1) {
    try {
      const res = await axios.get("/events/purchases", {
        params: { perPage, currentPage, pagesToLoad },
      });
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Fetch all the tickets
   *
  
   */
  async getAllTickets(perPage, currentPage, pagesToLoad = 1) {
    try {
      const res = await axios.get("/events/tickets", {
        params: { perPage, currentPage, pagesToLoad },
      });
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Scans ticket
   *
  
   */
  async scanTicket(ticketId, eventId) {
    try {
      const res = await axios.post(
        `/events/scan_ticket?ticketId=${ticketId}&eventId=${eventId}`
      );
      return {
        ok: true,
        data: res.data,
      };
    } catch (error) {
      // console.table(error, "api carnat");
      throw error;
    }
  },

  /**
   * Scans ticket
   *
  
   */
  async manualScanTicket(ticketId) {
    try {
      const res = await axios.patch(
        `/events/manual/scan_ticket?ticketId=${ticketId}`
      );
      return {
        ok: true,
        data: res.data,
      };
    } catch (error) {
      // console.table(error, "api carnat");
      throw error;
    }
  },

  /**
   * Fetch 1 ticket by id
   *
  
   */
  async getTicket(id) {
    try {
      const res = await axios.get(`/events/ticket/${id}`);
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Update ticked by ID
   *
   * @param {string} eventsId ID of the ticket to be updated

   */

  async updateTicket(id, ticket) {
    const obj = { ...ticket };

    try {
      const res = await axios.patch("/events/ticket/" + id, ticket);
      return {
        ok: true,
        data: res.data,
      };
    } catch (error) {
      return {
        ok: false,
        data: error,
      };
    }
  },

  /**
   * Get ticket files
   *
  
   */
  async getTicketFiles(purchaseId) {
    try {
      const res = await axios.get(
        `/events/ticket_files?purchaseId=${purchaseId}`,
        { responseType: "arraybuffer" }
      );
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Send one email
   *
   * @param {object} events Object with the email data
   * @return {object} Newly created email
   */
  async sendEmail(details) {
    let reqBody = { ...details };
    try {
      const res = await axios.post("/emails", reqBody);
      return {
        ok: true,
        data: res.data,
      };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Send email with attachments using FormData
   *
   * @param {FormData} formData FormData with email details and file attachments
   * @return {object} Response from email endpoint
   */
  async sendEmailWithAttachments(formData) {
    try {
      const res = await axios.post("/emails/with-attachments", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return {
        ok: true,
        data: res.data,
      };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Update Event by ID
   *
   * @param {string} eventsId ID of the Events to be updated
   * @return {string} ID of the updated Events
   */

  async update(id, event) {
    try {
      const res = await axios.patch("/events/" + id, event);
      return {
        ok: true,
        data: res.data,
      };
    } catch (error) {
      return {
        ok: false,
        data: error,
      };
    }
  },

  /**
   * Deletes Events by ID
   *
   * @param {string} eventsId ID of the Events to be deleted
   * @return {string} ID of the deleted Events
   */
  async delete(eventsId) {
    try {
      await axios.delete("/events/" + eventsId);
      return {
        ok: true,
        data: {
          id: eventsId,
        },
      };
    } catch (error) {
      return {
        ok: false,
        data: {
          id: eventsId,
        },
      };
    }
  },

  /**
   * Duplicates an existing event
   *
   * @param {string} eventId ID of the event to duplicate
   * @return {object} Newly created duplicated event
   */
  async duplicate(eventId) {
    try {
      const res = await axios.post(`/events/${eventId}/duplicate`);
      return {
        ok: true,
        data: res.data,
      };
    } catch (error) {
      return {
        ok: false,
        data: {},
        error: error.response?.data?.message || "Duplicate failed",
      };
    }
  },

  /**
   * Fetches events for each user
   *
   * @return {array} Array of Events's
   */
  async getEventsByUserId(userId) {
    try {
      const res = await axios.get("/events/events/byUserId", {
        params: {
          userId,
        },
      });
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: [],
      };
    }
  },

  /**
   * Fetches users who attended a specific event (for email filtering)
   *
   * @param {string} eventId ID of the event
   * @return {array} Array of users with attendance confirmed
   */
  async getEventAttendees(eventId) {
    try {
      const res = await axios.get(`/events/${eventId}/attendees`);
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: [],
      };
    }
  },

  /**
   * Add user to event presence
   *
   * @param {object} events Object with the creation data
   * @return {object} Newly created presence object
   */
  async createUserPresence(presence) {
    let reqBody = { ...presence };

    try {
      const res = await axios.post(
        `/events/confirmPresence?userId=${reqBody.userId}&eventId=${reqBody.eventId}`
      );
      return {
        ok: true,
        data: res.data,
      };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Fetches all events that contain the the specified string
   *
   * @param {string} text used to find events
   * @return {object} Array of events
   */
  async searchEvent(text) {
    try {
      const res = await axios.get(`/events/findString/text?text=${text}`);
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  async searchCustomEvents(text) {
    try {
      const res = await axios.get(`/events/custom_events/text?text=${text}`);
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Fetches future custom events
   *
   *
   * @return {object} Future custom events
   */
  async getFutureCustomEvents() {
    try {
      const res = await axios.get("/events/future_custom_events");
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Searches all tickets that contain the the specified string
   *
   * @param {string} text used to find ticket
   * @return {object} Array of tickets
   */
  async searchTicket(text) {
    try {
      const res = await axios.get(`events/tickets/text?text=${text}`);
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  async searchTicketsByEventId(eventId, text) {
    try {
      const res = await axios.get(
        `/events/custom_events/tickets/${eventId}?text=${text}`
      );
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Searches all transactions that contain the the specified string
   *
   * @param {string} text used to find transaction
   * @return {object} Array of transactions
   */
  async searchTransactions(text) {
    try {
      const res = await axios.get(`events/purchases/text?text=${text}`);
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  async downloadListOfTickets(eventId) {
    try {
      const res = await axios.get(`reports?eventId=${eventId}`, {
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "blob",
      });
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Upload event image
   * @param {string} eventId - The event ID
   * @param {File} file - The image file to upload
   */
  async uploadImage(eventId, file) {
    try {
      const formData = new FormData();
      formData.append("file", file);
      
      const res = await axios.post(`/event-images/${eventId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
        error: error.response?.data?.message || "Upload failed",
      };
    }
  },

  /**
   * Get event image URL - uses separate /event-images/ route
   * @param {string} eventId - The event ID
   * @param {number} cacheBuster - Optional timestamp to force cache refresh
   * @returns {string} Full URL to the event image
   */
  getImageUrl(eventId, cacheBuster = null) {
    const baseUrl = process.env.REACT_APP_API_BASE || "";
    const url = `${baseUrl}/event-images/${eventId}`;
    return cacheBuster ? `${url}?t=${cacheBuster}` : url;
  },

  /**
   * Delete event image
   * @param {string} eventId - The event ID
   */
  async deleteImage(eventId) {
    try {
      const res = await axios.delete(`/event-images/${eventId}`);
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
      };
    }
  },

  /**
   * Get comprehensive event report with all metrics
   * @param {string} eventId - The event ID
   * @returns {object} Event report with summary, audience, checkin flow, timing
   */
  async getEventReport(eventId) {
    try {
      const res = await axios.get(`/reports/event/${eventId}`);
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: {},
        error,
      };
    }
  },

  /**
   * Download event check-in report as PDF
   * @param {string} eventId - The event ID
   * @returns {object} Response with PDF blob
   */
  async downloadEventReportPDF(eventId) {
    try {
      const res = await axios.get(`/reports/event/${eventId}/pdf`, {
        responseType: "blob",
      });
      return { ok: true, data: res.data };
    } catch (error) {
      return {
        ok: false,
        data: null,
        error,
      };
    }
  },
};

export default Events;


